module.exports = __webpack_public_path__ + "media/images/lb/337-4b9e7ae555d7cddecb5b560f7f1fb855.svg";